import { render, staticRenderFns } from "./device-info-table.vue?vue&type=template&id=27c11641&scoped=true&"
import script from "./device-info-table.vue?vue&type=script&lang=ts&"
export * from "./device-info-table.vue?vue&type=script&lang=ts&"
import style0 from "./device-info-table.vue?vue&type=style&index=0&id=27c11641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c11641",
  null
  
)

export default component.exports